import WhmcsApi from '../services/WhmcsApi'

//Válida si ya se encuentra logueado en W
export const fetchValidateSession = async (token, setShowLoginExpired, setUserAuth) => {

    const whmcsApi = new WhmcsApi(); // Crear instancia de WhmcsApi
    const response = await whmcsApi.request('validateSession', {}, 'POST', token);
    if (response.result == 'success' || response.result == true) {
        setShowLoginExpired(false)
        setUserAuth(response.data);
    } else if (response.result == 'error') {
        localStorage.removeItem('userAuth');
        setUserAuth(null);
    }     
}; 

  export default fetchValidateSession;